export class GraphAuthTimeoutError extends Error {
  constructor() {
    super('Graph authentication did not become ready before the timeout.');
    this.name = 'GraphAuthTimeoutError';
  }
}
